
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6E42A", function(module, exports) {
$parcel$export(module.exports, "CtaSection", function () { return (parcelRequire("7IS0o")).CtaSection; });
$parcel$export(module.exports, "DataCenterSection", function () { return (parcelRequire("lYqKy")).DataCenterSection; });
$parcel$export(module.exports, "GartnerDisclaimer", function () { return (parcelRequire("jwbFO")).GartnerDisclaimer; });
$parcel$export(module.exports, "HeroEnterpriseTakeoverTurbo", function () { return (parcelRequire("iDNJX")).HeroEnterpriseTakeoverTurbo; });
$parcel$export(module.exports, "PlatformSection", function () { return (parcelRequire("fuhhv")).PlatformSection; });
$parcel$export(module.exports, "ResourcesSection", function () { return (parcelRequire("6cCqM")).ResourcesSection; });
$parcel$export(module.exports, "StatsSection", function () { return (parcelRequire("lk2q3")).StatsSection; });
$parcel$export(module.exports, "SupportSection", function () { return (parcelRequire("u4tJt")).SupportSection; });
$parcel$export(module.exports, "TabsSection", function () { return (parcelRequire("97gok")).TabsSection; });
$parcel$export(module.exports, "CarouselSection", function () { return (parcelRequire("lZygM")).CarouselSection; });
$parcel$export(module.exports, "EnterprisePageProductNav", function () { return (parcelRequire("6VSBC")).EnterprisePageProductNav; });
$parcel$export(module.exports, "HeroV2Section", function () { return (parcelRequire("EJqLv")).HeroV2Section; });
parcelRequire("7IS0o");
parcelRequire("lYqKy");
parcelRequire("jwbFO");
parcelRequire("1vLxv");
parcelRequire("iDNJX");
parcelRequire("fuhhv");
parcelRequire("6cCqM");
parcelRequire("lk2q3");
parcelRequire("u4tJt");
parcelRequire("97gok");
parcelRequire("lZygM");
parcelRequire("evuYk");
parcelRequire("6VSBC");
parcelRequire("EJqLv");

});
parcelRegister("7IS0o", function(module, exports) {
$parcel$export(module.exports, "CtaSection", function () { return $11580cc2f6e77cb1$export$a241c84f183c05c2; });
/* cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $4Jdkw = parcelRequire("4Jdkw");
const $11580cc2f6e77cb1$export$a241c84f183c05c2 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-cta",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            className: (0, $2jatx.default)([
                "_1itk11ql _ca0q1ylp _u5f3idpf _n3td1ylp _19bvidpf _vd3yidpf _mla21wug _kubfidpf _3x9r1wug"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Jdkw.ADG4CtaWithPolygonBackground), {
                header: intl.formatMessage({
                    id: "EnterpriseLandingPage.CallToActionSection.header",
                    defaultMessage: "Build your system of work with Atlassian"
                }),
                ctaText: intl.formatMessage({
                    id: "EnterpriseLandingPage.CallToActionSection.buttonText",
                    defaultMessage: "Contact sales"
                }),
                ctaUrl: (0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features"),
                ctaLabel: "Contact sales",
                productKey: "enterprise"
            })
        })
    });
};
const $11580cc2f6e77cb1$var$ctaSectionContainerStyle = null;

});

parcelRegister("lYqKy", function(module, exports) {
$parcel$export(module.exports, "DataCenterSection", function () { return $2140f2fe8e065770$export$3e74b76dd9e071d6; });
/* data-center.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $2140f2fe8e065770$export$3e74b76dd9e071d6 = ()=>{
    const intl = (0, $8e22h.default)();
    const dataCenterSectionContent = {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.headerText",
            defaultMessage: "Not ready to move to cloud?"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.bodyText",
            defaultMessage: "Atlassian Data Center is our self-managed, enterprise-grade offering designed for organizations with strict security and compliance requirements."
        }),
        linkText: intl.formatMessage({
            id: "EnterpriseLandingPage.DataCenterSection.linkText",
            defaultMessage: "Learn about Data Center"
        }),
        href: (0, $kooLp.useLocalizedHref)("/enterprise/data-center")
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-dataCenter",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            className: (0, $2jatx.default)([
                "_bfhk17fj _ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _quu713sl _3int1tcg _4fugzwfg _1ynq1tcg _1j3nzwfg _4sdyiec4 _12ce3739 _1tsvgktf _fd8v1txw _1bwb1q9c _1iievrvc _68jdvle5 _9u9rnxnw _19q81txw _12dhx19p _19pe1h6o _lmm31y6m _1yusvle5 _1hkovle5 _30721txw _y1mj1g80 _4vzb1w8u _m5gb1y6m _12vwzwfg _1crqcv93 _leujidpf _14zaidpf _1il1idpf _fs5uidpf _p5u7ftgi _bpkv1ul9 _1r27idpf _2lgdidpf _6wouidpf _1c7pidpf _1ppp1ogm _1lywftgi _5k731txw _1c2n1osq _5hes1j6v _qc6e1k8s _gvxubfng _nd0zzwfg _1mmnzwfg _awmxzwfg _1xi6zwfg _l7qw1g80 _ar0r1h6o _1p7u1osq _1ubi1h6o _18q6esu3 _1vumzwfg _fls593m8 _2uu193m8 _zbwo1txw _o3yo1g80 _i5yc1osq _13ku1h6o _dbaqidpf _1qoridpf _1a5bidpf _1rafidpf _1f1p1h6o _1j211tcg _1wfzidpf _212widpf _15d21crf _vh6pidpf _1nr81wug _1h01idpf _cc93idpf _e7z31crf _1u52idpf _14hs1osq _pd60glyw _fnxl1txw _rc231h6o _1ogs1osq"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: "data-center-container",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: "img-container",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: {
                                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-data-center-icon-3736035258.webp",
                                    alt: ""
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: "text-container",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                    children: dataCenterSectionContent.headerText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: dataCenterSectionContent.bodyText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    href: dataCenterSectionContent.href,
                                    text: dataCenterSectionContent.linkText,
                                    type: "primary",
                                    dataEventProps: {
                                        "data-label": dataCenterSectionContent.linkText,
                                        "data-product-key": "enterprise",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "dataCenterSection",
                                        "data-event": "clicked",
                                        "data-label-english": "Learn about Data Center"
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
const $2140f2fe8e065770$var$dataCenterSectionContainerStyle = null;

});

parcelRegister("jwbFO", function(module, exports) {
$parcel$export(module.exports, "GartnerDisclaimer", function () { return $5b60474b1056b2e6$export$46ba377055e90871; });
/* gartner-disclaimer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $5b60474b1056b2e6$var$finePrintStyles = null;
const $5b60474b1056b2e6$export$46ba377055e90871 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-disclaimer",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_syazfesn _18s81jx0",
                    "fine-print"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "EnterpriseLandingPage.gartnerDisclaimer",
                    defaultMessage: "* Gartner, Magic Quadrant for DevOps Platforms, Manjunath Bhat, Thomas Murphy, Joachim Herschmann, Daniel Betts, Chris Saunderson, Hassan Ennaciri, Bill Holz, Peter Hyde, 5 June 2023.  {br}{br} Gartner, Magic Quadrant for Enterprise Agile Planning Tools, Bill Blosen, Mike West, Keith Mann, Deacon D.K Wan, Akis Sklavounakis, Hassan Ennaciri, Sarah Davies, 25 April 2022.  {br}{br} Gartner, Voice of the Customer for Enterprise Agile Planning Tools, By Peer Contributors, 13 December 2023.  {br}{br} Gartner does not endorse any vendor, product or service depicted in its research publications, and does not advise technology users to select only those vendors with the highest ratings or other designation. Gartner research publications consist of the opinions of Gartner\u2019s research organization and should not be construed as statements of fact. Gartner disclaims all warranties, expressed or implied, with respect to this research, including any warranties of merchantability or fitness for a particular purpose.  {br}{br} Gartner Peer Insights content consists of the opinions of individual end users based on their own experiences with the vendors listed on the platform, should not be construed as statements of fact, nor do they represent the views of Gartner or its affiliates. Gartner does not endorse any vendor, product or service depicted in this content nor makes any warranties, expressed or implied, with respect to this content, about its accuracy or completeness, including any warranties of merchantability or fitness for a particular purpose.  {br}{br} GARTNER is a registered trademark and service mark, and the GARTNER PEER INSIGHTS CUSTOMERS\u2019 CHOICE badge, MAGIC QUADRANT and PEER INSIGHTS are trademarks and service marks, of Gartner, Inc. and/or its affiliates in the U.S. and internationally and are used herein with permission. All rights reserved.",
                    values: (0, $kooLp.DEFAULT_VALUES)
                })
            })
        })
    });

});

parcelRegister("1vLxv", function(module, exports) {
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $5qUgh = parcelRequire("5qUgh");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $d426652f1eda45bf$export$4489c2ed11909944 = ()=>{
    const intl = (0, $8e22h.default)();
    const heroSectionHeaderText = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "EnterpriseLandingPage.Hero.Title",
        defaultMessage: "Transform <span>teamwork at scale</span> with Atlassian",
        values: (0, $kooLp.DEFAULT_VALUES)
    });
    const heroSectionButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.Hero.ContactSales",
        defaultMessage: "Contact sales"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-hero",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1xusidpf _pdfi1ul9 _hfczidpf _t0uc1ul9 _1humidpf _vxqx1wqb _m3vkidpf _l2as1wqb _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                alignItems: "center",
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1j444cyy _10j0ubw4 _1cbbgktf _l9wpidpf _f4o91wqb _14dmidpf _xgqm1zx8 _2h35g6j5 _bzzima1m _18jm1wqb _qji6idpf _ms0l1wqb _v5weidpf _1bl41w8u _b2g01l0k _13hpuihq _1isq1ikj _y3gn1h6o _kqswh2mm _19it1i89 _2rkogktf _19pk1wqb _2hwxidpf _otyr1wqb _18u0idpf _1reo15vq _18m915vq _1tke1edt _1itk105u _ouxlvvtf _12vemgnk _1lrw9efu _1e8sbxu3 _psnd1osr _q4ef6276 _18tn1fw0 _dkzuidpf _17f71wug _at0e1ul9 _1nx01wug _bpsp1nn1"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                            className: "superhero-contrast",
                            children: heroSectionHeaderText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                            variant: "primary",
                            href: (0, $kooLp.useLocalizedHref)("/enterprise/contact?formType=product-features"),
                            dataEventProps: {
                                "data-product-key": "enterprise",
                                "data-event-component": "linkButton",
                                "data-event-container": "ctaSection",
                                "data-event": "clicked",
                                "data-label": heroSectionButtonText,
                                "data-label-english": "Contact sales"
                            },
                            children: heroSectionButtonText
                        })
                    ]
                })
            })
        })
    });
};
const $d426652f1eda45bf$var$heroStyle = null;
const $d426652f1eda45bf$var$heroSectionBoxStyle = null;

});

parcelRegister("iDNJX", function(module, exports) {
$parcel$export(module.exports, "HeroEnterpriseTakeoverTurbo", function () { return $774d158b0a94a674$export$5f34b2edc97abcd5; });
/* hero-takeover-turbo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $5qUgh = parcelRequire("5qUgh");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $32ng3 = parcelRequire("32ng3");
const $774d158b0a94a674$export$5f34b2edc97abcd5 = ()=>{
    const intl = (0, $8e22h.default)();
    const ctaLink = (0, $kooLp.useLocalizedHref)("/enterprise/atlassian-williams-racing");
    const turboBodyText = intl.formatMessage({
        id: "HomePage.hero-turbo.body-text",
        defaultMessage: "Introducing Atlassian Williams Racing. Two teamwork powerhouses join forces to usher in a new era of Formula 1 racing."
    });
    const turboFeatureGate = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp5046TurboBannerEnterprise);
    if (turboFeatureGate) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "homepage-turbo",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1reo15vq _18m915vq _11q7jk2v _18s8zucw _mkrz95kk"
            ]),
            style: {
                "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1e0c1txw _4cvr1h6o _zulptudo _1bsb1fra _p12f1osq _1yt415v9 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _na0i1bp4 _gu181h6o _dh1a1h6o _2osnpxbi _o5kc1h6o _6ssjnl7l"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1e0c1txw _zulp1ejb _2lx21bp4 _4cvr1y6m _1bsb9tyk _acte1nn1 _qpk8yn4p _dd34idpf _l0uhidpf _ldjiidpf _g49yidpf _mihdcjiy _m78dcd5j _1tc71693 _1qf11ule _1hzvviql _vubcviql _125xcd5j _q7gqoxwj _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _txws1k92 _1kt119ii _19qkdgin _ov511osq _1s4p1wug _8fz6dgin _6ssj1e2i _gu181h6o _dh1a1h6o _o5kc1h6o"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: "hero hero-turbo",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "HomePage.hero-turbo.heading",
                                    defaultMessage: "Unleash the <strong>power of teamwork</strong>",
                                    values: (0, $kooLp.DEFAULT_VALUES)
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: "turbo",
                                children: turboBodyText
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                variant: "primary",
                                color: "yellow",
                                size: "large",
                                href: ctaLink,
                                dataEventProps: {
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    // @ts-ignore
                                    "data-event-container": "turboHero",
                                    "data-product-key": "home",
                                    "data-label-english": "Find out more"
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                    id: "HomePage.hero-turbo.cta-link-livery",
                                    defaultMessage: "Find out more"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1yt41jx0 _1bsb16tw _mezj1osq _bna71wug _18zx1kb5 _1s4p1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                            image: {
                                alt: "",
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4l06vv7x28fd2whw3f1i721165ooydn4.webp"
                            }
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
};
const $774d158b0a94a674$var$heroTurboCSS = null;
const $774d158b0a94a674$var$containingWidth = null;
const $774d158b0a94a674$var$leftHero = null;
const $774d158b0a94a674$var$rightHero = null;
$774d158b0a94a674$export$5f34b2edc97abcd5.displayName = "HeroEnterpriseTakeoverTurbo";

});

parcelRegister("fuhhv", function(module, exports) {
$parcel$export(module.exports, "PlatformSection", function () { return $f2e85d00bdce9b0b$export$156caa82c28797f7; });
/* platform.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $fl7Kz = parcelRequire("fl7Kz");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $f2e85d00bdce9b0b$export$156caa82c28797f7 = ()=>{
    const intl = (0, $8e22h.default)();
    const platformCardsCrossProductExperience = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.collaboration.headerText",
                defaultMessage: "Collaboration"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.collaboration.bodyText",
                defaultMessage: "Keep work flowing across teams and tools."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/platform/collaboration"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.intelligence.headerText",
                defaultMessage: "Intelligence"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.intelligence.bodyText",
                defaultMessage: "Transform teamwork with the power of AI-human collaboration."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/artificial-intelligence"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.automation.headerText",
                defaultMessage: "Automation"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.automation.bodyText",
                defaultMessage: "Replace manual, time-consuming work with modern workflows."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/platform/automation"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.analytics.headerText",
                defaultMessage: "Analytics"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.analytics.bodyText",
                defaultMessage: "Make faster decisions with accessible data-informed insights."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/platform/analytics"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.extensibility.headerText",
                defaultMessage: "Extensibility"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.crossProductExperince.card.extensibility.bodyText",
                defaultMessage: "Customize your tools to meet the unique needs of each team."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: "https://marketplace.atlassian.com/",
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.crossProductExperince.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        }
    ];
    const platformCardsEnterpriseGradeCapabilities = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.resilience.headerText",
                defaultMessage: "Resilience at scale"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.resilience.bodyText",
                defaultMessage: "Adapt to any challenge with software designed to dynamically scale to meet the needs of any team, regardless of size or complexity."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/trust/resilience"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.security.headerText",
                defaultMessage: "Security and compliance"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.security.bodyText",
                defaultMessage: "Meet regulatory requirements and effectively manage your organization's data using comprehensive controls."
            }),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/trust/data-protection"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "platformSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilities.card.linkText",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-platformSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_ca0q1ylp _u5f3idpf _n3td1ylp _19bvidpf _1sc1zwfg _1o2nzwfg _16zdidpf _jvlqidpf _1j3nzwfg _4fugzwfg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o _q7gqgktf _w77horz4 _clfdftgi _11pq1wug _q0a5ftgi _c3k81wug"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            children: intl.formatMessage({
                                id: "EnterpriseLandingPage.Platform.headerText",
                                defaultMessage: "Unify your teams on one powerful platform"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_bfhk1t97 _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1h6o _1x1tidpf _s9kqidpf _4wztidpf _98csidpf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.crossProductExperince.headerText",
                                        defaultMessage: "Experiences built to help work flow"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_19pkzwfg _2hwx1wug _otyrzwfg _18u01wug _1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _1n261q9c _zulpzwfg _ohma7vkz _iz1bzlre _1seo1wug _ox5hglyw _1f7i1osq _1r6y7vkz _1d9j7vkz _tuj67vkz _1cae7vkz _1m5l7vkz _bapsidpf _24o4idpf _ru7pidpf _1pqjidpf _1oan1fw0 _ax17ftgi _2axr1osq _1swwidpf _bzvvidpf _1dr6idpf _1o9tidpf _7dyf1j6v _scyo1k8s _1xaw1g80 _1rrc1tcg _1sgw17i6 _161z1osq"
                                    ]),
                                    children: platformCardsCrossProductExperience.map((cardProps, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $fl7Kz.default), {
                                            className: "platform-row-one-card",
                                            ...cardProps
                                        }, index))
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ip65idpf _g8ou1wug _1opiidpf _1x951wug _dmb7idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_bfhkcs0v _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1h6o _1x1tidpf _s9kqidpf _4wztidpf _98csidpf _clfd7vkz _11pq1wug _q0a57vkz _c3k81wug _w77horz4 _kckd1w8u _19tb1j6v _1la11k8s _bpspbfng"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.commonDataModel.headerText",
                                        defaultMessage: "A common data model designed to unlock key insights"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.commonDataModel.bodyText",
                                        defaultMessage: "Unify Atlassian and third-party data to connect teams, deepen collaboration, and drive results."
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                    type: "primary",
                                    href: (0, $kooLp.useLocalizedHref)("/platform"),
                                    text: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.commonDataModel.linkText",
                                        defaultMessage: "Learn about our platform"
                                    }),
                                    dataEventProps: {
                                        "data-product-key": "enterprise",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "platformSection",
                                        "data-event": "clicked",
                                        "data-label": intl.formatMessage({
                                            id: "EnterpriseLandingPage.Platform.commonDataModel.dataLabel",
                                            defaultMessage: "Learn about our platform"
                                        }),
                                        "data-label-english": "Learn about our platform"
                                    }
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_ip65idpf _g8ou1wug _1opiidpf _1x951wug _dmb7idpf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_bfhk1ymo _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _y3gn1h6o _1x1tidpf _s9kqidpf _4wztidpf _98csidpf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                    children: intl.formatMessage({
                                        id: "EnterpriseLandingPage.Platform.enterpriseGradeCapabilites.headerText",
                                        defaultMessage: "All built on enterprise-grade foundations"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_19pkzwfg _2hwx1wug _otyrzwfg _18u01wug _1bsb1w8u _1e0c1txw _1bah1h6o _1n261q9c _zulpzwfg _1wa17vkz _1ull1ssb _10ql1wug _tlbsglyw _lz7x1osq _knw07vkz _w3mz7vkz _14877vkz _6mwl7vkz _xc0a7vkz _19elidpf _wsnuidpf _1lioidpf _rkcxidpf _14uv1fw0 _x8poftgi _2fdk1osq _6qlpidpf _7m8oidpf _196hidpf _47ltidpf _1b8g1j6v _1xzh1k8s _1qza1osq _11901g80 _17duzwfg _kyxpidpf _3x14zwfg _p8qcidpf _rvvr1osq"
                                    ]),
                                    children: platformCardsEnterpriseGradeCapabilities.map((cardProps, index)=>{
                                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fl7Kz.default), {
                                            className: "platform-row-three-card",
                                            ...cardProps
                                        }, index);
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
const $f2e85d00bdce9b0b$var$platformSectionBoxContainer = null;
const $f2e85d00bdce9b0b$var$platformBoxContainer = null;
const $f2e85d00bdce9b0b$var$platformSectionHeaderContainerStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionBoxRowOneStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionRowOneCardContainerStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionBoxRowTwoStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionBoxRowThreeStyle = null;
const $f2e85d00bdce9b0b$var$platformSectionRowThreeCardContainerStyle = null;

});

parcelRegister("6cCqM", function(module, exports) {
$parcel$export(module.exports, "ResourcesSection", function () { return $a415d9d03629612e$export$3f0336208d56829f; });
/* resources.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $2fk4i = parcelRequire("2fk4i");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $a415d9d03629612e$export$3f0336208d56829f = ()=>{
    const intl = (0, $8e22h.default)();
    const tileList = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.trustCenter.headerText",
                defaultMessage: "Trust Center"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.trustCenter.bodyText",
                defaultMessage: "Keep your organization\u2019s data secure, maintain compliance, and achieve resilience at scale."
            }),
            imageProps: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/trust-center-cloud-icon-3087608378.webp",
                alt: ""
            },
            linkProps: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.Resources.card.trustCenter.linkText",
                    defaultMessage: "Visit our Trust Center"
                }),
                href: (0, $kooLp.useLocalizedHref)("/trust"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "resourcesSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.Resources.card.trustCenter.dataLabel",
                        defaultMessage: "Visit our Trust Center"
                    }),
                    "data-label-english": "Visit our Trust Center"
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.publicRoadmap.headerText",
                defaultMessage: "Public Roadmap"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.publicRoadmap.bodyText",
                defaultMessage: "Discover the latest features in the Atlassian cloud and see what we\u2019re working on next."
            }),
            imageProps: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/curved-arrow-icon-3497580723.webp",
                alt: ""
            },
            linkProps: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.Resources.card.publicRoadmap.linkText",
                    defaultMessage: "Check out the Cloud Roadmap"
                }),
                href: (0, $kooLp.useLocalizedHref)("/roadmap/cloud"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "resourcesSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.Resources.card.publicRoadmap.dataLabel",
                        defaultMessage: "Check out the Cloud Roadmap"
                    }),
                    "data-label-english": "Check out the Cloud Roadmap"
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.community.headerText",
                defaultMessage: "Enterprise Community"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Resources.card.community.bodyText",
                defaultMessage: "Ask questions and learn best practices for our products at scale from Atlassian advocates."
            }),
            imageProps: {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/community-bubble-icon-3561157108.webp",
                alt: ""
            },
            linkProps: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.Resources.card.community.linkText",
                    defaultMessage: "Join the Enterprise Community"
                }),
                href: "https://community.atlassian.com/t5/Enterprise/gh-p/Enterprise",
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "resourcesSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.Resources.card.community.dataLabel",
                        defaultMessage: "Join the Enterprise Community"
                    }),
                    "data-label-english": "Join the Enterprise Community"
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-resourcesSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_ca0qzwfg _u5f3idpf _n3tdidpf _19bvidpf _1afj1h6o _l5k11fw0 _16qeidpf _3ontidpf _19szidpf _i5bbidpf _cw8vusvi _hycy1txw _pg7i1bp4 _ezjiidpf _n5mbidpf _ypkd1tcg _1a0jidpf _14tm1ule _ix4uidpf _1gb7mhvn _64bp1osq _41c21txw _1iyj1osq _1kkgftgi _zkiw1e5h _fhnp1bp4 _1jxlzwfg _uuujidpf _1tu71fw0 _wft81crf _1jklidpf _1l021osq _178z1tcg _zlemidpf _ibgk1ul9 _o6yp1j6v _1syj1k8s _1chlbfng _wsbmf6fq _irte1j6v _w2lm1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        children: intl.formatMessage({
                            id: "EnterpriseLandingPage.Resources.sectionHeader",
                            defaultMessage: "Teamwork starts with trust"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "4-4-4",
                    children: tileList.map((content, index)=>{
                        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: "resources-section-container",
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: "img-section",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                                        src: content.imageProps.src,
                                        alt: content.imageProps.alt,
                                        className: (0, $2jatx.default)([
                                            "_1h1t1fut _5ral1f51",
                                            "enterprise-resources-card-image"
                                        ])
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    className: "text-section",
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                            children: content.headerText
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: "contentBlock-body",
                                            children: content.bodyText
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: "contentBlock-linkFlex",
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                                text: content.linkProps.text,
                                                href: content.linkProps.href,
                                                dataEventProps: content.linkProps.dataEventProps,
                                                type: "primary"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
const $a415d9d03629612e$var$resourcesSectionContainerStyle = null;

});

parcelRegister("lk2q3", function(module, exports) {
$parcel$export(module.exports, "StatsSection", function () { return $34a1992600616f27$export$49e22b3583223277; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $4Fnxt = parcelRequire("4Fnxt");

var $32ng3 = parcelRequire("32ng3");
const $34a1992600616f27$export$49e22b3583223277 = ()=>{
    const gwp7518NavIconUpdates = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp7518NavIconUpdates);
    const intl = (0, $8e22h.default)();
    const statsProps = {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.stats.header",
            defaultMessage: "High-performing enterprises run on Atlassian"
        }),
        bigStat: {
            stat: "200",
            statText: intl.formatMessage({
                id: "EnterpriseLandingPage.stats.bigText",
                defaultMessage: "countries around the world where Atlassian software helps power enterprise"
            }),
            statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
            statSymbol: {
                symbolCharacter: "+",
                symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: "44",
                statText: intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText1",
                    defaultMessage: "of enterprise customers are able to make faster data-driven decisions after moving to the cloud"
                }),
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            },
            {
                stat: "79",
                statText: gwp7518NavIconUpdates ? intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText2-gwp-7518",
                    defaultMessage: "of enterprise customers are satisfied with Atlassian cloud apps"
                }) : intl.formatMessage({
                    id: "EnterpriseLandingPage.stats.littleText2",
                    defaultMessage: "of enterprise customers are satisfied with Atlassian cloud products"
                }),
                statColor: (0, $kbpa7.wacToken)("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: "%",
                    symbolCharacterColor: (0, $kbpa7.wacToken)("color.primary.blue")
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-stats",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Fnxt.Stats), {
                ...statsProps
            })
        })
    });
};

});

parcelRegister("u4tJt", function(module, exports) {
$parcel$export(module.exports, "SupportSection", function () { return $906e979b456f42a3$export$17b1756ef4d0cdd6; });
/* support.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $fl7Kz = parcelRequire("fl7Kz");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $906e979b456f42a3$export$17b1756ef4d0cdd6 = ()=>{
    const intl = (0, $8e22h.default)();
    const cardList = [
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.headerText.advisoryServices",
                defaultMessage: "Advisory Services"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.bodyText.advisoryServices",
                defaultMessage: "Maximize your Atlassian investment and achieve your goals with strategic, technical, and practice guidance from Atlassian\u2019s in-house experts."
            }),
            iconName: "lightning",
            iconSize: "small",
            clickableCardUrl: (0, $kooLp.useLocalizedHref)("/enterprise/services/advisory-services"),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/enterprise/services/advisory-services"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "supportSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.headerText.enterprisePartners",
                defaultMessage: "Enterprise Partners"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.bodyText.enterprisePartners",
                defaultMessage: "Consulting, hands-on technical implementation, and best practices to optimize your Atlassian portfolio and ensure your success."
            }),
            iconName: "partners",
            iconSize: "small",
            clickableCardUrl: (0, $kooLp.useLocalizedHref)("/enterprise/enterprise-partners"),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/enterprise/enterprise-partners"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "supportSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        },
        {
            headerText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.headerText.customerSupport",
                defaultMessage: "Customer Support"
            }),
            bodyText: intl.formatMessage({
                id: "EnterpriseLandingPage.Support.card.bodyText.customerSupport",
                defaultMessage: "Get 24/7 support with 30-minute response times for critical issues included with Cloud Enterprise and Data Center subscriptions."
            }),
            iconName: "sparkle",
            iconSize: "small",
            clickableCardUrl: (0, $kooLp.useLocalizedHref)("/enterprise/support-services"),
            ctaProps: {
                primaryLinkProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/enterprise/support-services"),
                    type: "primary",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "supportSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.card.linkText.learnMore",
                            defaultMessage: "Learn more"
                        }),
                        "data-label-english": "Learn more"
                    }
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-supportSection",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
            className: (0, $2jatx.default)([
                "_bfhk17fj _85i51ylp _94n51n1a _1afj1h6o _l5k11fw0 _1eavgktf _7qsbtlke _4mdwglyw _nmva14mp _8mry16gf _ajae1tcg _17s71tcg _1uza1tcg _18bc1tcg _bo1n1osq _1gm71fw0 _5hjp1osq _1xi9idpf _1yay1j6v _1k931k8s _cwu5jojz _9rk41fp4 _wxo81jeb _1qj31yy8"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        children: intl.formatMessage({
                            id: "EnterpriseLandingPage.Support.headerText",
                            defaultMessage: "Support designed for every enterprise"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "4-4-4",
                    children: cardList.map((CardProps, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $fl7Kz.default), {
                            className: `support-section-card support-section-card-${index}`,
                            headerType: "h4",
                            ...CardProps
                        }, index))
                })
            ]
        })
    });
};
const $906e979b456f42a3$var$SupportSectionContainerStyles = null;
var $906e979b456f42a3$export$2e2bcd8739ae039 = $906e979b456f42a3$export$17b1756ef4d0cdd6;

});

parcelRegister("97gok", function(module, exports) {
$parcel$export(module.exports, "TabsSection", function () { return $aefc41f18298c8bf$export$502de1d4d55224c1; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $6hzTZ = parcelRequire("6hzTZ");
parcelRequire("jy5WX");
var $l4cHn = parcelRequire("l4cHn");
var $2EsR9 = parcelRequire("2EsR9");
var $8uEmY = parcelRequire("8uEmY");
var $3Fv2O = parcelRequire("3Fv2O");
const $aefc41f18298c8bf$export$502de1d4d55224c1 = ()=>{
    const intl = (0, $8e22h.default)();
    const tabs = [
        {
            id: "tab1",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.softwareDevelopment",
                defaultMessage: "Software development"
            }),
            englishLabel: "Software development",
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2EsR9.EnterpriseSoftwareDevelopment), {})
        },
        {
            id: "tab2",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.Service management",
                defaultMessage: "Service management"
            }),
            englishLabel: "Service management",
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l4cHn.EnterpriseServiceManagement), {})
        },
        {
            id: "tab3",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterpriseStrategyAndPlanning",
                defaultMessage: "Enterprise strategy & planning"
            }),
            englishLabel: "Enterprise strategy & planning",
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8uEmY.EnterpriseStrategyAndPlanning), {})
        },
        {
            id: "tab4",
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.workManagement",
                defaultMessage: "Work management"
            }),
            englishLabel: "Work management",
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Fv2O.EnterpriseWorkManagement), {})
        }
    ];
    const solutionsHeader = intl.formatMessage({
        id: "EnterpriseLandingPage.solutions.header",
        defaultMessage: "Industry-leading solutions to accelerate your business"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-tabs",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6hzTZ.TabsWithCards), {
            h2Text: solutionsHeader,
            tabsData: tabs
        })
    });
};

});
parcelRegister("jy5WX", function(module, exports) {
$parcel$export(module.exports, "EnterpriseStrategyAndPlanning", function () { return (parcelRequire("8uEmY")).EnterpriseStrategyAndPlanning; });
$parcel$export(module.exports, "EnterpriseServiceManagement", function () { return (parcelRequire("l4cHn")).EnterpriseServiceManagement; });
$parcel$export(module.exports, "EnterpriseSoftwareDevelopment", function () { return (parcelRequire("2EsR9")).EnterpriseSoftwareDevelopment; });
$parcel$export(module.exports, "EnterpriseWorkManagement", function () { return (parcelRequire("3Fv2O")).EnterpriseWorkManagement; });

var $8uEmY = parcelRequire("8uEmY");

var $l4cHn = parcelRequire("l4cHn");

var $2EsR9 = parcelRequire("2EsR9");

var $3Fv2O = parcelRequire("3Fv2O");

});
parcelRegister("8uEmY", function(module, exports) {
$parcel$export(module.exports, "EnterpriseStrategyAndPlanning", function () { return $bf6dd4cff04406bb$export$b230c8e7621aa6c7; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");

var $hcrIp = parcelRequire("hcrIp");
const $bf6dd4cff04406bb$export$b230c8e7621aa6c7 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.makeAllWorkVisible",
                    defaultMessage: "Make all work visible in real-time"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.makeAllWorkVisible.bodytext",
                    defaultMessage: "Spot and solve blockers faster with visibility into all work from teams across your enterprise."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.alignEveryTeam",
                    defaultMessage: "Align every team to strategy"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.alignEveryTeam.bodyText",
                    defaultMessage: "Get everyone on the same page so you can solve for dependencies, scope, and roadmaps across teams and portfolios."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.stayFocusedOnCustomerValue",
                    defaultMessage: "Stay focused on customer value"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.stayFocusedOnCustomerValue.bodyText",
                    defaultMessage: "Map investments to customer value creation so you can make confident decisions at make-or-break moments."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.StrategyAndPlanning.learnMore",
                defaultMessage: "Learn about enterprise strategy & planning"
            }),
            link: (0, $kooLp.useLocalizedHref)("/software/jira/align"),
            linkLabel: "Learn about enterprise strategy & planning",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/1tu5g7e71x67ptt70udllxtw5705vl17.webp",
                alt: "",
                width: 1544,
                height: 1092
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.StrategyAndPlanning.resources",
            defaultMessage: "Enterprise strategy & planning resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport",
                    defaultMessage: "Report"
                }),
                headerText: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport.headerText",
                    defaultMessage: 'Gartner<sup>\xae</sup> Predicts 2024: Strategic Portfolio Leaders Must Plan for the "Never Normal"',
                    values: (0, $hcrIp.formatRegisteredSymbol)
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.predictsReport.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("software/jira/align/resources/gartner-strategic-portfolio-management"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/kx4vls2kbgf442m7wq2p88a182k0sy20.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar",
                    defaultMessage: "Demo center"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar.headerText",
                    defaultMessage: "Learn how to boost Enterprise Strategy & Planning with Jira Align"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.reportWebinar.linkText",
                        defaultMessage: "Explore demos"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/software/jira/align/demo"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Explore demos"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-02-demo@2x-3880751788.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide",
                    defaultMessage: "Webinar"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide.headerText",
                    defaultMessage: "Transformations Across Hybrid Environments"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.StrategyAndPlanning.card.ITSMGuide.linkText",
                        defaultMessage: "Watch webinar"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/webinars/agile-at-scale/transformations-across-hybrid-environments"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Watch webinar"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/kv2eo50o020nn5amk6ahukj52h35405s.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});
parcelRegister("hcrIp", function(module, exports) {
$parcel$export(module.exports, "formatRegisteredSymbol", function () { return $0b8f8eb27e7a388e$export$7c6a07146a40a24d; });
/* utils.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $0b8f8eb27e7a388e$export$7c6a07146a40a24d = {
    sup: (chunks)=>/*#__PURE__*/ (0, $7VQPk.jsx)("sup", {
            className: (0, $2jatx.default)([
                "_vwz4idpf"
            ]),
            children: chunks
        })
};

});


parcelRegister("l4cHn", function(module, exports) {
$parcel$export(module.exports, "EnterpriseServiceManagement", function () { return $acbe78da1a3d03fc$export$851060687c9906bd; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");
const $acbe78da1a3d03fc$export$851060687c9906bd = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.deliverValue",
                    defaultMessage: "Deliver value fast"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.deliverValue.bodytext",
                    defaultMessage: "Replace costly legacy tools and deploy faster with a powerful, easy-to-use platform that has transparent pricing."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.accelerateDevOps",
                    defaultMessage: "Accelerate dev and ops"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.accelerateDevOps.bodyText",
                    defaultMessage: "Instead of siloed tools, increase visibility and the flow of work by connecting Development and IT Operations teams on a single platform."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.empowerServiceForAll",
                    defaultMessage: "Empower service for all"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.empowerServiceForAll.bodyText",
                    defaultMessage: "Help every team take ownership of their service experience and scale practices - without costly add-ons or confusing deployments."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.serviceManagement.learnMore",
                defaultMessage: "Learn about service management"
            }),
            link: (0, $kooLp.useLocalizedHref)("/solutions/itsm"),
            linkLabel: "Learn about service management",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/x2s3unwoyy1xp3222df5pu0j23fx7lki.webp",
                alt: "",
                width: 1544,
                height: 1092
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.serviceManagement.resources",
            defaultMessage: "Service management resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport",
                    defaultMessage: "Forrester report"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport.headerText",
                    defaultMessage: "Atlassian is a Leader in Enterprise Service Management, Q4 2023"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.forresterReport.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/forrester/wave-enterprise-service-management"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/forresterWave-3356930698.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar",
                    defaultMessage: "ROI resources"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar.headerText",
                    defaultMessage: "The Total Economic Impact of Jira Service Management"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.reportWebinar.linkText",
                        defaultMessage: "Explore resources"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/jira/service-management/total-economic-impact-hub"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Explore resources"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/totEconomicImpact-1137923345.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide",
                    defaultMessage: "Guide"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide.headerText",
                    defaultMessage: "ITSM for high-velocity teams"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.serviceManagement.card.ITSMGuide.linkText",
                        defaultMessage: "Download guide"
                    }),
                    href: "https://wac-cdn.atlassian.com/it/dam/jcr:4ec50253-90f1-4d6c-98e2-2ff994cf94db/Jira-Service-Management-Overview-Datasheet.pdf?cdnVersion=1275#:~:text=Jira%20Service%20Management%20offers%20business,approach%20of%20legacy%20ITSM%20solutions.&text=Empower%20all%20teams%20across%20IT,business%20with%20intuitive%2C%20flexible%20workflows.&text=Make%20work%20visible%20through%20the%20open%20and%20collaborative%20Jira%20platform.",
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Download guide"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/itServiceMngmt-1552092334.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});

parcelRegister("2EsR9", function(module, exports) {
$parcel$export(module.exports, "EnterpriseSoftwareDevelopment", function () { return $94aadbde708c2ed9$export$24da22834a2c8907; });

var $7VQPk = parcelRequire("7VQPk");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");

var $hcrIp = parcelRequire("hcrIp");
const $94aadbde708c2ed9$export$24da22834a2c8907 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.supercharge",
                    defaultMessage: "Supercharge dev productivity"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.supercharge.bodytext",
                    defaultMessage: "Reduce bottlenecks and keep your software teams in the flow with everything you need to discover, plan, build, and operate world-class software."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.eliminateSilos",
                    defaultMessage: "Eliminate knowledge silos"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.eliminateSilos.bodyText",
                    defaultMessage: "Create better harmony between software and business teams by keeping work visible across your entire organization."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.accelerateDevops.driveBetterOutcomes",
                    defaultMessage: "Drive better business outcomes"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.accelerateDevops.driveBetterOutcomes.bodyText",
                    defaultMessage: "Connect and visualize data from all of your Atlassian and third-party tools to make faster and more informed decisions."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.softwareDevelopment.learnMore",
                defaultMessage: "Learn about software development"
            }),
            link: (0, $kooLp.useLocalizedHref)("/teams/software-development"),
            linkLabel: "Learn about software development",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5kq1t5b8yd8rfi6b617314esnw1mt5ra.webp",
                alt: "",
                width: 1544,
                height: 1092
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.softwareDevelopment.resources",
            defaultMessage: "Software development resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps",
                    defaultMessage: "Solutions"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps.headerText",
                    defaultMessage: "Open DevOps: Keep your tools, ditch the setup"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.openDevOps.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/solutions/devops"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Learn more"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-01-solutions@2x-310314428.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant",
                    defaultMessage: "Report"
                }),
                headerText: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant.headerText",
                    defaultMessage: "Atlassian named a Leader in the 2024 Gartner<sup>\xae</sup> Magic Quadrant\u2122 for DevOps Platforms",
                    values: (0, $hcrIp.formatRegisteredSymbol)
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.magicQuadrant.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/gartner/magic-quadrant-devops"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-01-report@2x-1971220130.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo",
                    defaultMessage: "Demo"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo.headerText",
                    defaultMessage: "Maximize Developer Experience Demo"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.softwareDevelopment.card.devExDemo.linkText",
                        defaultMessage: "Watch on-demand"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/webinars/enterprise-cloud/Maximize-Developer-Experience-with-Atlassian"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Watch on-demand"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/software-03-demo@2x-531224759.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});

parcelRegister("3Fv2O", function(module, exports) {
$parcel$export(module.exports, "EnterpriseWorkManagement", function () { return $70db6bec80cf2dea$export$26da8c8cc9d60467; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $682Ua = parcelRequire("682Ua");

var $kooLp = parcelRequire("kooLp");
const $70db6bec80cf2dea$export$26da8c8cc9d60467 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $682Ua.default), {
        contentList: [
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.planForSuccess",
                    defaultMessage: "Plan for success"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.planForSuccess.bodytext",
                    defaultMessage: "Create, communicate, and organize your plans and content to make it easier for all teams to discover your org\u2019s most important work."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.collaborateOnSharedGoals",
                    defaultMessage: "Collaborate on shared goals"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.collaborateOnSharedGoals.bodyText",
                    defaultMessage: "Track and communicate your goals by sharing project status to keep everyone across your organization has visibility into work being done."
                })
            },
            {
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.flexYourWays",
                    defaultMessage: "Flex your ways of working"
                }),
                headerType: "h4",
                bodyText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.flexYourWays.bodyText",
                    defaultMessage: "Let your teams work the way they prefer, using their own process, language, and views while still staying connected to other team\u2019s projects."
                })
            }
        ],
        contentLink: {
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.WorkManagement.learnMore",
                defaultMessage: "Learn about work management"
            }),
            link: (0, $kooLp.useLocalizedHref)("/solutions/work-management"),
            linkLabel: "Learn about work management",
            productKey: "enterprise"
        },
        pictureProps: {
            image: {
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/65p0f3lsvwv2tt0v473y166n7i4147ad.webp",
                alt: "",
                width: 1519,
                height: 1093
            }
        },
        tabContentEyebrowText: intl.formatMessage({
            id: "EnterpriseLandingPage.tab.WorkManagement.resources",
            defaultMessage: "Work management resources"
        }),
        cardsContent: [
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools",
                    defaultMessage: "Solutions"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools.headerText",
                    defaultMessage: "Atlassian Work Management solutions and tools"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.workMngmtSolutionsAndTools.linkText",
                        defaultMessage: "Learn more"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/solutions/work-management"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Learn more"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-01-solutions@2x-3900037778.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt",
                    defaultMessage: "Guide"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt.headerText",
                    defaultMessage: "A Comprehensive Guide to Work Management"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.guideToWorkMngmt.linkText",
                        defaultMessage: "Get the guide"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/blog/work-management/guide-to-work-management-2024"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Get the guide"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-02-guide@2x-511342337.webp",
                        alt: ""
                    }
                }
            },
            {
                eyebrowText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide",
                    defaultMessage: "Report"
                }),
                headerText: intl.formatMessage({
                    id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide.headerText",
                    defaultMessage: "The economic benefits of improving work management with Atlassian"
                }),
                ctaProps: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.tab.WorkManagement.card.ITSMGuide.linkText",
                        defaultMessage: "Read report"
                    }),
                    href: (0, $kooLp.useLocalizedHref)("/whitepapers/esg-work-management-report"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "resourcesSection",
                        "data-event": "clicked",
                        "data-label-english": "Read report"
                    }
                },
                pictureProps: {
                    image: {
                        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/work-03-report@2x-1528241620.webp",
                        alt: ""
                    }
                }
            }
        ]
    });
};

});



parcelRegister("lZygM", function(module, exports) {
$parcel$export(module.exports, "CarouselSection", function () { return $98754143592a1482$export$5edf3752a9da9c72; });
/* carousel-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $7rz8I = parcelRequire("7rz8I");

var $dweoU = parcelRequire("dweoU");
const $98754143592a1482$export$5edf3752a9da9c72 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4nbubfng"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
            name: "enterprise-page-testimonials",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7rz8I.ADG4CustomerTestimonials), {
                bgColor: "black",
                heading: intl.formatMessage({
                    id: "EnterpriseLandingPage.carousel.heading",
                    defaultMessage: "Trusted by over 80% of the Fortune 500"
                }),
                cta: {
                    text: intl.formatMessage({
                        id: "EnterpriseLandingPage.carousel.heading.cta",
                        defaultMessage: "Explore all customers stories"
                    }),
                    url: (0, $kooLp.useLocalizedHref)("/customers?filterByEnterprise=true"),
                    dataEventProps: {
                        "data-product-key": "enterprise",
                        "data-event-component": "linkButton",
                        "data-event-container": "customersSection",
                        "data-event": "clicked",
                        "data-label": intl.formatMessage({
                            id: "EnterpriseLandingPage.carousel.heading.ctaDataLabel",
                            defaultMessage: "Explore all customers stories"
                        }),
                        "data-label-english": "Explore all customers stories"
                    }
                },
                testimonials: $98754143592a1482$var$Testimonials(),
                className: "customer-stories-carousel"
            })
        })
    });
};
const $98754143592a1482$var$Testimonials = ()=>{
    const intl = (0, $8e22h.default)();
    const testimonials = [
        {
            name: "Sun Life Employee",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialSunLife), {}),
            title: "",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 SunLife on Black 2x 1-2143605095.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial1.quote",
                defaultMessage: "Jira Cloud and Confluence Cloud are a big step in the right direction from the previous tools we were using. All the new functionality really improved my day to day."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial1.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/sunlife"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial1.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Sun Life"
        },
        {
            name: "Mehmet Sari",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialMercedesBenz), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial2.title",
                defaultMessage: "Modern Collaboration Platform Team, Mercedes-Benz"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 Mercedes-Benz on Black 2x 1-2641411897.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial2.quote",
                defaultMessage: "Atlassian cloud is the solution for high performance, high security, high availability, and the newest features."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial2.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/mercedes-benz"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial2.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Mercedes Benz"
        },
        {
            name: "Ryan Mosley",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialDHCS), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial3.title",
                defaultMessage: "Chief of Factory & Engineering Modernization, DHCS"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 DHCS on Black 2x 1-2317410165.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial3.quote",
                defaultMessage: "By tracking everything in Jira and all of our developer tools, we reduced the cost to get the team set up and deliver the product from $2.8 million to $600,000."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial3.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/dhcs"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial3.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "DHCS California Department of Health Care Services"
        },
        {
            name: "Mai Lian Scarlett",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialLumen), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial4.title",
                defaultMessage: "Former Senior Director, Agile Transformation Office, Lumen"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 Lumen on Black 2x 1-2939378294.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial4.quote",
                defaultMessage: "Our partnership with Atlassian has really been an accelerator and an enabler to our digital transformation\u2026We\u2019re excited to see Atlassian\u2019s commitment to the cloud platform."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial4.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/lumen"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial4.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Lumen"
        },
        {
            name: "Oxana Trotsenko",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialUnited), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial5.title",
                defaultMessage: "Chief of Staff of Digital Technology, United Airlines"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 United on Black 2x 1-995190318.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial5.quote",
                defaultMessage: "Atlassian cloud provides you flexibility, cost savings over time, and efficiency\u2026When I think about technology in the modern world, we would not consider anything else."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial5.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/united-airlines"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial5.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "United Airlines"
        },
        {
            name: "Evan Lerer",
            logo: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dweoU.TestimonialRedfin), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial6.title",
                defaultMessage: "Director of Engineering, Redfin"
            }),
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-10860 Redfin on Black 2x 1-8548123.webp",
            quote: intl.formatMessage({
                id: "EnterpriseLandingPage.testimonial6.quote",
                defaultMessage: "We trust Atlassian to help our team deliver world-class products that redefine real estate in the customer\u2019s favor."
            }),
            link: {
                text: intl.formatMessage({
                    id: "EnterpriseLandingPage.testimonial6.link.text",
                    defaultMessage: "Read customer story"
                }),
                url: (0, $kooLp.useLocalizedHref)("/customers/redfin"),
                dataEventProps: {
                    "data-product-key": "enterprise",
                    "data-event-component": "linkButton",
                    "data-event-container": "customersSection",
                    "data-event": "clicked",
                    "data-label": intl.formatMessage({
                        id: "EnterpriseLandingPage.testimonial6.link.linkDataLabel",
                        defaultMessage: "Read customer story"
                    }),
                    "data-label-english": "Read customer story"
                }
            },
            label: "Redfin"
        }
    ];
    return testimonials;
};
const $98754143592a1482$var$carouselSectionStyles = null;

});

parcelRegister("evuYk", function(module, exports) {
/* badges.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kooLp = parcelRequire("kooLp");

var $jMhSx = parcelRequire("jMhSx");
const $7cbd5ae14e10bec6$export$a81af8b662eb2b7 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-badges",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_6rth8ved"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_y3gn1h6o _6rth19bv",
                        "eyebrow-md"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                        id: "EnterpriseLandingPage.badges.eyebrow",
                        defaultMessage: "Recognized by world-class analysts"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                    layout: "3-3-3-3",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($7cbd5ae14e10bec6$var$Badge, {
                            href: (0, $kooLp.useLocalizedHref)("/forrester/wave-enterprise-service-management"),
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/forrester_wave_leader_2023-3286669196.webp",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge1",
                                defaultMessage: "Atlassian is a Leader in The Forrester Wave\u2122: Enterprise Service Management, Q4 2023."
                            }),
                            badgeLabel: "Atlassian is a Leader in The Forrester Wave\u2122: Enterprise Service Management, Q4 2023."
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($7cbd5ae14e10bec6$var$Badge, {
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner_logo.svg",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge2",
                                defaultMessage: "A Leader in the 2023 Gartner\xae Magic Quadrant\u2122 for DevOps Platforms*"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($7cbd5ae14e10bec6$var$Badge, {
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/gartner_logo.svg",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge3",
                                defaultMessage: "A Leader in the 2023 Gartner\xae Magic Quadrant\u2122 for Enterprise Agile Planning Tools*"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($7cbd5ae14e10bec6$var$Badge, {
                            imageUrl: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Peer-Insights-Customers-Choice-2023.svg",
                            imageAlt: "",
                            badgeText: intl.formatMessage({
                                id: "EnterpriseLandingPage.badges.badge4",
                                defaultMessage: "A Gartner\xae Peer Insights\u2122 Customers' Choice for Enterprise Agile Planning Tools."
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $7cbd5ae14e10bec6$var$badgeSectionStyles = null;
const $7cbd5ae14e10bec6$var$divStyles = null;
const $7cbd5ae14e10bec6$var$Badge = ({ href: href, imageUrl: imageUrl, imageAlt: imageAlt, badgeText: badgeText, badgeLabel: badgeLabel })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1ml653f4 _kmx4ys9h _q1391ule _1cac1wug _14fh1wug _gdebo7ao _qgibo7ao _1bsa1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
            href: href,
            "data-product-key": "enterprise",
            "data-event-component": "link",
            "data-event-container": "badgesSection",
            "data-event": "clicked",
            "data-label": badgeText,
            "data-label-english": badgeLabel,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "image-container",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: imageUrl,
                        alt: imageAlt
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "badge-text body-sm",
                    children: badgeText
                })
            ]
        })
    });
};
const $7cbd5ae14e10bec6$var$BadgeStyles = null;

});

parcelRegister("EJqLv", function(module, exports) {
$parcel$export(module.exports, "HeroV2Section", function () { return $ca865e303881e7c7$export$cd8aff68574ce209; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $i0Jom = parcelRequire("i0Jom");

var $4Im8f = parcelRequire("4Im8f");

var $8hNiC = parcelRequire("8hNiC");

var $liM7f = parcelRequire("liM7f");
const $ca865e303881e7c7$export$11abae89ba61f3a8 = 8000;
const $ca865e303881e7c7$export$cd8aff68574ce209 = ()=>{
    const intl = (0, $8e22h.default)();
    const tabs = [
        {
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8hNiC.EnterpriseTabContent), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterprise",
                defaultMessage: "Enterprise"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterprise.caption",
                defaultMessage: "Atlassian\u2019s System of Work"
            }),
            englishLabel: "enterprise",
            id: "enterprise"
        },
        {
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $liM7f.ProductTabContent), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.product",
                defaultMessage: "Product"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.product.caption",
                defaultMessage: "Atlassian\u2019s latest AI innovation"
            }),
            englishLabel: "product",
            id: "product"
        },
        {
            tabComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Im8f.AnalystsTabContent), {}),
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.analysts",
                defaultMessage: "Analysts"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.analysts.caption",
                defaultMessage: "Gartner Magic Quadrant Leader"
            }),
            englishLabel: "analysts",
            id: "analysts"
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i0Jom.EnterpriseTabsWithCards), {
        tabsData: tabs,
        tabSwitchInterval: $ca865e303881e7c7$export$11abae89ba61f3a8
    });
};

});
parcelRegister("i0Jom", function(module, exports) {
$parcel$export(module.exports, "EnterpriseTabsWithCards", function () { return $81937f6de4338711$export$255fc2fb2ce9d4ee; });
/* enterprise-tabs-with-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $a9lfn = parcelRequire("a9lfn");
const $81937f6de4338711$var$Tab = ({ title: title, caption: caption, isSelected: isSelected, dataEventProps: dataEventProps })=>{
    const eyebrowStyle = null;
    const captionStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        ...dataEventProps,
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bsb1ns9 _4t3i1osq _1tkekz1e _p12f5jys _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _2lx21bp4 _4cvr1y6m _80omtlke _16jlkb7n _2rkogktf _19itglyw _11q7u66n _16qss1rx _ect4lnmy _k48p1nn1 _1wybgktf _syaz1iem _152tr8pp _v5641gvb _1mdbkz1e _uhd05jys _1j96zwfg _jvmrzwfg _k0mszwfg _1b7pzwfg _1x6l13rr _j6qupd6w _xut117n1 _ceho8wlv _jx4017n1 _1i7q122r _1dbzyicz",
            isSelected && "_19it1oen _16qsyicz _syazr3uz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect48q0o _1wybdlk8 _zg8l4jg8 _k48p1nn1 _vwz4f6fq _1p1dangw _19pkidpf _2hwxidpf _otyr7vkz _18u0idpf"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect4kipj _1wybf6fq _zg8l4jg8 _k48p1fw0 _vwz41tcg _y3gn1e5h _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1fhb _1bsb1osq"
                ]),
                children: caption
            })
        ]
    });
};
const $81937f6de4338711$export$255fc2fb2ce9d4ee = ({ tabsData: tabsData, tabSwitchInterval: tabSwitchInterval })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "tabs",
        className: (0, $2jatx.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $a9lfn.Adg4Tabs), {
            tabSwitchInterval: tabSwitchInterval,
            loop: true,
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1ule"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4TabPanel), {
                            panelIndex: index,
                            id: tab.id,
                            children: tab.tabComponent
                        }, index))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1e0c1ule _1pbycs5v _152tr8pp"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTabList), {
                        rowGap: "12px",
                        className: (0, $2jatx.default)([
                            "_ca0qidpf _u5f31wqb _n3td1qjk _19bv1wqb _1e0c1txw _4cvr1fhb _zulpzwfg _1kmxidpf _1ggmzwfg _1ykz1ul9 _1maezwfg",
                            "tab-list"
                        ]),
                        children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTab), {
                                tabIndex: index,
                                className: "round-tab",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($81937f6de4338711$var$Tab, {
                                    title: tab.title,
                                    caption: tab.caption,
                                    dataEventProps: {
                                        "data-product-key": "home",
                                        "data-event": "clicked",
                                        "data-event-component": "button",
                                        "data-event-container": "tabsMenu",
                                        "data-label": tab.title,
                                        "data-label-english": tab.englishLabel
                                    }
                                })
                            }, index))
                    })
                })
            ]
        })
    });
};
const $81937f6de4338711$var$topSectionStyles = null;
const $81937f6de4338711$var$bottomSectionStyles = null;
const $81937f6de4338711$var$sectionStyles = null;
const $81937f6de4338711$var$tabList = null;
const $81937f6de4338711$var$tabStyles = null;
const $81937f6de4338711$var$currentStyle = null;

});

parcelRegister("4Im8f", function(module, exports) {
$parcel$export(module.exports, "AnalystsTabContent", function () { return $a799074227eeb47f$export$bfe5f81b459a55ca; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $flDFL = parcelRequire("flDFL");

var $kooLp = parcelRequire("kooLp");
const $a799074227eeb47f$export$bfe5f81b459a55ca = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $flDFL.EnterpriseHero), {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.analysts.header",
            defaultMessage: "Atlassian named a Leader in DevOps Platforms by Gartner"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.analysts.body",
            defaultMessage: "Learn about our unified DevOps platform that connects engineering, IT Ops, and business teams"
        }),
        textAlign: "right",
        cta: {
            text: intl.formatMessage({
                id: "EnterpriseLandingPage.hero.analysts.cta",
                defaultMessage: "Read the report"
            }),
            dataEventProps: {
                "data-product-key": "enterprise",
                "data-event-component": "linkButton",
                "data-event-container": "heroSection",
                "data-event": "clicked",
                "data-label": "enterprise-hero-analysts-cta",
                "data-label-english": "Read the report"
            },
            href: (0, $kooLp.useLocalizedHref)("/gartner/magic-quadrant-devops")
        },
        ctaType: "button",
        color: "light",
        backgroundImgSrc: {
            xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-xs.webp",
            sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-sm.webp",
            md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-md.webp",
            lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-carousel/bg-mag-quad-lg.webp"
        }
    });
};

});
parcelRegister("flDFL", function(module, exports) {
$parcel$export(module.exports, "EnterpriseHero", function () { return $69fdc043b04a07d0$export$9d702f5b43ea4715; });
/* enterprise-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $5qUgh = parcelRequire("5qUgh");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $69fdc043b04a07d0$var$contentMaxWidth = {
    center: {
        xs: "378px",
        sm: "534px",
        md: "568px",
        lg: "568px"
    },
    left: {
        xs: "378px",
        sm: "421px",
        md: "514px",
        lg: "568px"
    },
    right: {
        xs: "378px",
        sm: "365px",
        md: "514px",
        lg: "668px"
    }
};
const $69fdc043b04a07d0$export$9d702f5b43ea4715 = ({ headerText: headerText, bodyText: bodyText, textAlign: textAlign = "center", color: color = "light", cta: cta, ctaType: ctaType, backgroundImgSrc: backgroundImgSrc })=>{
    const textColor = color === "light" ? (0, $kbpa7.wacToken)("color.neutral.light0") : (0, $kbpa7.wacToken)("color.primary.black");
    const inlineStart = textAlign === "left" ? "199.5px" : textAlign === "right" ? "-140px" : "0";
    const alignItems = textAlign === "left" ? "flex-start" : textAlign === "right" ? "flex-end" : "center";
    const justifyContent = textAlign === "left" ? "flex-start" : textAlign === "right" ? "flex-end" : "center";
    const containerStyle = null;
    const { md: md, lg: lg } = $69fdc043b04a07d0$var$contentMaxWidth[textAlign];
    const contentStyle = null;
    const headerStyle = null;
    const bodyStyle = null;
    const ctaStyle = null;
    const CallToAction = ()=>{
        if (!cta) return null;
        if (ctaType === "button") {
            const { text: text, href: href, dataEventProps: dataEventProps } = cta;
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                variant: "primary",
                size: "small",
                color: "yellow",
                href: href,
                dataEventProps: dataEventProps,
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1wpzn3xj _es5ofn2t _1gwbyfnk"
                ]),
                style: {
                    "--_k2wmiu": (0, $6ZVlx.default)(alignItems),
                    "--_2idk6s": (0, $6ZVlx.default)(textAlign === "center" ? "center" : "flex-start"),
                    "--_1t1mgkw": (0, $6ZVlx.default)(textAlign === "right" ? "center" : alignItems)
                },
                children: text
            });
        } else if (ctaType === "link") {
            const { text: text, href: href, dataEventProps: dataEventProps } = cta;
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                type: "external",
                href: href,
                text: text,
                dataEventProps: dataEventProps
            });
        }
        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
            children: cta
        });
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_y44v19jp _11q7xprm _p12fklux _4t3i1c5i _1o9zidpf _kqswh2mm _19pk1wqb _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3zwfg _n3tdidpf _19bvzwfg _1e0c1txw _1bahjlb8 _4cvr1h6o _yj3y1b9g _1d4udzi4 _1j96idpf _jvmr1wqb _k0msidpf _1b7p1wqb _ibctnzkm _v8ts8nql _2ysd8nql"
        ]),
        style: {
            "--_n0tana": (0, $6ZVlx.default)(backgroundImgSrc?.xs, ")", "url("),
            "--_1ecqhzh": (0, $6ZVlx.default)(justifyContent),
            "--_188fmqn": (0, $6ZVlx.default)(textAlign === "right" ? "center" : justifyContent),
            "--_c4618e": (0, $6ZVlx.default)(textAlign === "right" ? `url(${backgroundImgSrc?.xs}) 50% / 100% 100% no-repeat` : `url(${backgroundImgSrc?.sm}) 50% / cover no-repeat`),
            "--_450zrg": (0, $6ZVlx.default)(backgroundImgSrc?.md, ")", "url("),
            "--_11tlo2t": (0, $6ZVlx.default)(backgroundImgSrc?.lg, ")", "url(")
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1e0c1txw _2lx21bp4 _1bahkeqs _4cvrn3xj _18s81any _y3gn2i2r _p12f1oh5 _7bccng7t _b14zybpo _sfxvybpo _10vrkeqs _yir31oh5 _1rsv1oh5 _1190gb00 _ytj9ydnc"
            ]),
            style: {
                "--_ux0pmw": (0, $6ZVlx.default)(textAlign),
                "--_k2wmiu": (0, $6ZVlx.default)(alignItems),
                "--_1x9bz3": (0, $6ZVlx.default)(textAlign === "center" ? "0 auto" : "0"),
                "--_xk83tk": (0, $6ZVlx.default)(textAlign === "center" ? "center" : "left"),
                "--_14ulcc6": (0, $6ZVlx.default)(textAlign === "right" ? "center" : textAlign),
                "--_1itq52x": (0, $6ZVlx.default)(inlineStart),
                "--_1ndsstv": (0, $6ZVlx.default)(textAlign === "right" ? "668px" : "568px")
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_ect41pz4 _1wybigbc _zg8l4jg8 _k48p9y44 _vwz4v9r7 _18s81khp _syaz1u00 _50pk12am _167l1ady _1sg4idpf _maxsidpf _1jvh1f4h _1ucaidpf _b14zybpo _17gq8vuz _1s18ckbl _15flidpf _1d2widpf _1svy7vkz _seovidpf",
                        "enterprise-hero-header-text"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display")),
                        "--_j86zen": (0, $6ZVlx.default)(textAlign === "right" ? "10vw" : "44px"),
                        "--_1l1q5sn": (0, $6ZVlx.default)(textAlign === "right" ? "12vw" : "50px"),
                        "--_192zam2": (0, $6ZVlx.default)(textAlign === "right" ? "0 0 5vw 0" : "0 0 28px 0"),
                        "--_srel9g": (0, $6ZVlx.default)(textColor),
                        "--_14ulcc6": (0, $6ZVlx.default)(textAlign === "right" ? "center" : textAlign)
                    },
                    children: headerText
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_ect4bzd7 _1wyb7vkz _zg8l4jg8 _k48p1nn1 _vwz41tcg _4t3i1ns9 _c71lt9kd _1bsb1ns9 _19pkidpf _2hwxidpf _otyr1f4h _18u0idpf _syaz1u00 _b14zybpo _1dxp1yu0 _1sg4idpf _maxsidpf _1jvhzwfg _1ucaidpf _b8yq1ns9 _1s18gktf _17gq1f4h"
                    ]),
                    style: {
                        "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text")),
                        "--_srel9g": (0, $6ZVlx.default)(textColor),
                        "--_14ulcc6": (0, $6ZVlx.default)(textAlign === "right" ? "center" : textAlign)
                    },
                    children: bodyText
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)(CallToAction, {})
            ]
        })
    });
};

});


parcelRegister("8hNiC", function(module, exports) {
$parcel$export(module.exports, "EnterpriseTabContent", function () { return $4e88cce0cf69ea64$export$6b3a3100e0e8582e; });
/* eslint-disable local/no-non-orangelogic-images-eslint */ 
var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $flDFL = parcelRequire("flDFL");
const $4e88cce0cf69ea64$export$6b3a3100e0e8582e = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $flDFL.EnterpriseHero), {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.enterprise-new.headerText",
            defaultMessage: "Forward Together"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.enterprise-new.bodyText",
            defaultMessage: "Discover how Atlassian Williams Racing is accelerating teamwork transformation on the grid using the Atlassian Cloud Platform."
        }),
        cta: {
            text: intl.formatMessage({
                id: "EnterpriseLandingPage.hero.enterprise.cta",
                defaultMessage: "Watch video"
            }),
            dataEventProps: {
                "data-product-key": "enterprise",
                "data-event-component": "linkButton",
                "data-event-container": "heroSection",
                "data-event": "clicked",
                "data-label": "enterprise-hero-enterprise-cta",
                "data-label-english": "Watch video"
            },
            href: "https://www.youtube.com/watch?v=sSKY7pNdlvI"
        },
        ctaType: "link",
        color: "dark",
        backgroundImgSrc: {
            xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-sm-107626183.webp",
            sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-md-2984500272.webp",
            md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-lg-2107118674.webp",
            lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/enterprise-hero-enterprise-bg-1621379571.webp"
        }
    });
};

});

parcelRegister("liM7f", function(module, exports) {
$parcel$export(module.exports, "ProductTabContent", function () { return $f4ffa76e12bb7992$export$36e1444062b1b431; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $flDFL = parcelRequire("flDFL");

var $kooLp = parcelRequire("kooLp");
const $f4ffa76e12bb7992$export$36e1444062b1b431 = ()=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $flDFL.EnterpriseHero), {
        headerText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.product.header",
            defaultMessage: "Say Hello to Rovo"
        }),
        bodyText: intl.formatMessage({
            id: "EnterpriseLandingPage.hero.product.body",
            defaultMessage: "Atlassian's AI-powered solution that makes teamwork easier and faster."
        }),
        textAlign: "center",
        cta: {
            text: intl.formatMessage({
                id: "EnterpriseLandingPage.hero.product.cta",
                defaultMessage: "Learn more"
            }),
            dataEventProps: {
                "data-product-key": "enterprise",
                "data-event-component": "linkButton",
                "data-event-container": "heroSection",
                "data-event": "clicked",
                "data-label": "enterprise-hero-product-cta",
                "data-label-english": "Learn more"
            },
            href: (0, $kooLp.useLocalizedHref)("/software/rovo")
        },
        ctaType: "button",
        color: "dark",
        backgroundImgSrc: {
            xs: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-mobile@2x-1408243573.webp",
            sm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-tablet@2x-1411287807.webp",
            md: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-desktop-S@2x-1748573145.webp",
            lg: "https://wac-cdn.atlassian.com/misc-assets/webp-images/bg-rovo-desktop-L@2x-2396412742.webp"
        }
    });
};

});




//# sourceMappingURL=enterprise-contact-sales-page.0a3f0c18.js.map
